(function catalogSearch(){
'use strict';
const root=document.querySelector('[data-cabane-catalog-root][data-cabane-collection-search="true"]');
if(!root)return;
const fields='[data-cabane-catalog-search]', container=document.getElementById('ProductGridContainer');
const section=root.dataset.cabaneSection, pageSize=Number(root.dataset.cabanePageSize)||24, saleOnly=root.dataset.cabaneSaleOnly==='true';
const gridClass=document.getElementById('product-grid')?.className.includes('product-grid')?document.getElementById('product-grid').className:`grid product-grid grid--${root.dataset.cabaneColumnsMobile||2}-col-tablet-down grid--${root.dataset.cabaneColumnsDesktop||4}-col-desktop`;
const word=(fr,en)=>document.documentElement.lang.startsWith('en')?en:fr;
const fold=value=>String(value||'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLowerCase();
let version=0,timer,cache;
const choiceDataNode=document.querySelector('[data-scooter-choice-products]');
const choiceGroups=choiceDataNode?JSON.parse(choiceDataNode.textContent):{};
const choiceKey=params=>Object.prototype.hasOwnProperty.call(choiceGroups,params.get('cabane_selection'))?params.get('cabane_selection'):'';
const sync=value=>document.querySelectorAll(fields).forEach(field=>{if(field.value!==value)field.value=value;});
const baseURL=params=>{const url=new URL(location.pathname,location.origin);url.search=new URLSearchParams(params).toString();['cabane_q','cabane_selection','cabane_page','page','section_id','sections','view'].forEach(key=>url.searchParams.delete(key));return url;};
const initialBase=baseURL(location.search).href;
const initialPage=Number(new URLSearchParams(location.search).get('page'))||1;
const initialDocument=document.documentElement.cloneNode(true);
function getCache(params){
  const base=baseURL(params);
  if(cache?.base.href===base.href)return cache;
  cache?.controller.abort();
  cache={base,controller:new AbortController(),pages:new Map(),index:null};
  if(base.href===initialBase)cache.pages.set(initialPage,Promise.resolve(initialDocument));
  return cache;
}
async function pageDocument(state,page){
  if(!state.pages.has(page)){
    const url=new URL(state.base);url.searchParams.set('section_id',section);url.searchParams.set('page',page);
    const promise=fetch(url,{signal:state.controller.signal}).then(response=>{if(!response.ok)throw Error('Collection unavailable');return response.text();}).then(html=>new DOMParser().parseFromString(html,'text/html')).catch(error=>{state.pages.delete(page);throw error;});
    state.pages.set(page,promise);
  }
  return state.pages.get(page);
}
async function index(state){
  if(!state.index)state.index=(async()=>{
    const items=[];let page=1,pages=1;
    do{
      const url=new URL(state.base);url.searchParams.set('view','cabane-search-index');url.searchParams.set('page',page);
      const response=await fetch(url,{signal:state.controller.signal});
      if(!response.ok)throw Error('Index unavailable');
      const data=await response.json();
      if(!Array.isArray(data.items)||!Number.isInteger(data.pages))throw Error('Invalid index');
      for(const item of data.items)items.push({...item,position:items.length,terms:fold([item.title,item.vendor,item.type,...(item.tags||[])].join(' '))});
      pages=data.pages;page++;
    }while(page<=pages);
    return items;
  })().catch(error=>{state.index=null;throw error;});
  return state.index;
}
function status(message,error=false){
  let el=container.querySelector('[data-catalog-search-status]');
  if(!el){el=document.createElement('p');el.dataset.catalogSearchStatus='';el.className='cabane-catalog__search-status';container.prepend(el);}
  el.setAttribute('role',error?'alert':'status');el.textContent=message;
}
function busy(value){
  root.setAttribute('aria-busy',String(value));
  container.querySelector('.collection')?.classList.toggle('loading',value);
  if(!value){
    document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner').forEach(el=>el.classList.add('hidden'));
    document.querySelectorAll('#ProductCount,#ProductCountDesktop').forEach(el=>el.classList.remove('loading'));
    if(typeof FacetFiltersForm!=='undefined')FacetFiltersForm.toggleActiveFacets(false);
  }
}
function catalogPagination(page,pages,params){
  const wrapper=document.createElement('div');wrapper.className='pagination-wrapper';
  const nav=document.createElement('nav');nav.className='pagination';nav.setAttribute('aria-label',word('Pagination','Pagination'));
  const list=document.createElement('ul');list.className='pagination__list list-unstyled';list.setAttribute('role','list');
  const caret=()=>{const svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('class','icon icon-caret');svg.setAttribute('viewBox','0 0 26 26');svg.setAttribute('data-cabane-arrow','down');svg.setAttribute('aria-hidden','true');const path=document.createElementNS(svg.namespaceURI,'path');path.setAttribute('d','M1 1l4 4 4-4');path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');svg.append(path);return svg;};
  const add=(target,text,kind)=>{
    const li=document.createElement('li');if(kind)li.className='pagination__'+kind+'-control';
    const el=document.createElement(target===page?'span':'a');el.className='pagination__item '+(target===page?'pagination__item--current light':'link');
    el.setAttribute('aria-label',kind?word(kind==='next'?'Page suivante':'Page précédente',kind==='next'?'Next page':'Previous page'):word('Page ','Page ')+target);
    if(target===page)el.setAttribute('aria-current','page');
    else{
      const url=new URL(location.href);url.search=new URLSearchParams(params).toString();url.searchParams.set('cabane_page',target);url.hash='';el.href=url.href;
      el.addEventListener('click',event=>{
        if(event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
        event.preventDefault();void render(url.searchParams,null,true,true);
      });
    }
    if(kind){el.classList.add('pagination__item-arrow','motion-reduce',kind==='next'?'pagination__item--prev':'pagination__item--next');if(kind==='next'){const label=document.createElement('span');label.textContent=text;el.append(label);}el.append(caret());}
    else el.textContent=text;
    li.append(el);list.append(li);
  };
  if(page>1)add(page-1,'','previous');
  const start=page>=pages-1?pages-2:page-1,end=page<=2?3:page+1;
  let gap=false;
  for(let n=1;n<=pages;n++){
    if(n!==1&&n!==pages&&(n<start||n>end)){gap=true;continue;}
    if(gap){const li=document.createElement('li');li.className='pagination__gap';const span=document.createElement('span');span.className='pagination__item';span.textContent='…';span.setAttribute('aria-hidden','true');li.append(span);list.append(li);gap=false;}
    add(n,String(n),'');
  }
  if(page<pages)add(page+1,word('Page suivante','Next page'),'next');
  nav.append(list);wrapper.append(nav);return wrapper;
}
async function render(params,event,updateHistory=true,scrollToResults=false){
  params=new URLSearchParams(params);const term=(params.get('cabane_q')||'').trim();
  const selection=choiceKey(params);
  const ticket=++version;
  if(!term&&!saleOnly&&!selection){
    root.classList.remove('is-searching');sync('');
    params.delete('cabane_page');
    return false;
  }
  sync(term);root.classList.add('is-searching');busy(true);
  if(typeof FacetFiltersForm!=='undefined')FacetFiltersForm.searchParamsPrev=params.toString();
  status(word('Recherche dans cette catégorie…','Searching this category…'));
  if(updateHistory)history.pushState({searchParams:params.toString()},'',`${location.pathname}${params.size?'?'+params:''}`);
  const state=getCache(params);
  try{
    const [items,first]=await Promise.all([index(state),pageDocument(state,1)]);
    if(ticket!==version)return true;
    const tokens=fold(term).split(/\s+/).filter(Boolean);
    const allowed=selection?new Set(choiceGroups[selection]):null;
    const matches=items.filter(item=>(!saleOnly||item.sale)&&(!allowed||allowed.has(item.id))&&tokens.every(token=>item.terms.includes(token)));
    const pages=Math.max(1,Math.ceil(matches.length/pageSize));
    const page=Math.max(1,Math.min(pages,Number(params.get('cabane_page'))||1));
    const shown=matches.slice((page-1)*pageSize,page*pageSize);
    const needed=[...new Set(shown.map(item=>Math.floor(item.position/pageSize)+1))];
    const documents=new Map();let cursor=0;
    await Promise.all(Array.from({length:Math.min(3,needed.length)},async()=>{
      while(cursor<needed.length){const number=needed[cursor++];documents.set(number,await pageDocument(state,number));}
    }));
    if(ticket!==version)return true;
    const cards=shown.map(item=>{
      const doc=documents.get(Math.floor(item.position/pageSize)+1);
      const node=doc.querySelector(`[data-cabane-product-id="${item.id}"]`);
      if(!node)throw Error('Result card unavailable');
      const clone=node.cloneNode(true);clone.classList.remove('scroll-trigger','animate--slide-in');clone.removeAttribute('style');return clone;
    });
    if(typeof FacetFiltersForm!=='undefined')FacetFiltersForm.renderFilters(first.outerHTML||first.documentElement.outerHTML,event);
    root.querySelectorAll('.facets__label .facet-checkbox__text, .facets__label .visually-hidden, .mobile-facets__label .facet-checkbox__text, .mobile-facets__label .visually-hidden').forEach(label=>{
      label.textContent=label.textContent.replace(/\s*\(\s*\d+[^()]*\)\s*$/, '').trim();
    });
    const collection=document.createElement('div');collection.className='collection';
    const grid=document.createElement('ul');grid.id='product-grid';grid.dataset.id=section;grid.className=gridClass;grid.append(...cards);collection.append(grid);
    container.replaceChildren(collection);
    if(!matches.length)status(word('Aucun produit ne correspond à cette recherche dans cette catégorie.','No products match this search in this category.'));
    if(pages>1){
      collection.append(catalogPagination(page,pages,params));
    }
    document.querySelectorAll('#ProductCount,#ProductCountDesktop').forEach(el=>{el.textContent=`${matches.length} ${word(matches.length===1?'résultat':'résultats',matches.length===1?'result':'results')}`;el.dataset.cabaneServerCount=el.textContent;});
    if(selection)root.querySelectorAll('.mobile-facets__count').forEach(el=>{el.textContent=`${matches.length} ${word(matches.length===1?'résultat':'résultats',matches.length===1?'result':'results')}`;});
    document.dispatchEvent(new CustomEvent('cabane:catalog-updated'));
    busy(false);
    if(scrollToResults&&window.matchMedia('(max-width: 749px)').matches){
      grid.setAttribute('tabindex','-1');grid.focus({preventScroll:true});
      const header=document.querySelector('.lcg-header, .section-header');
      const offset=(header?.getBoundingClientRect().height||0)+16;
      window.scrollTo({top:Math.max(0,window.scrollY+grid.getBoundingClientRect().top-offset),behavior:'instant'});
    }
  }catch(error){
    if(ticket!==version||error.name==='AbortError')return true;
    busy(false);status(word('Impossible de charger les résultats. Réessaie.','Unable to load the results. Please try again.'),true);
  }
  return true;
}
function search(value){
  clearTimeout(timer);
  const params=new URLSearchParams(location.search);
  params.delete('page');params.delete('cabane_page');params.delete('section_id');
  value=value.trim();if(value)params.set('cabane_q',value);else params.delete('cabane_q');
  if(!value&&!saleOnly&&!choiceKey(params)){
    ++version;root.classList.remove('is-searching');sync('');
    if(typeof FacetFiltersForm!=='undefined')FacetFiltersForm.renderPage(params.toString());
    else location.assign(`${location.pathname}?${params}`);
  }else void render(params,null,true);
}
window.CabaneCatalogSearch={
  handleFilters(params,event,updateHistory){
    const parsed=new URLSearchParams(params);
    if(!parsed.get('cabane_q')&&!saleOnly&&!choiceKey(parsed)){++version;root.classList.remove('is-searching');sync('');return false;}
    void render(parsed,event,updateHistory);return true;
  }
};
document.addEventListener('input',event=>{
  if(!event.target.matches?.(fields))return;
  event.stopPropagation();++version;sync(event.target.value);clearTimeout(timer);
  if(!event.isComposing)timer=setTimeout(()=>search(event.target.value),400);
},true);
document.addEventListener('compositionend',event=>{if(event.target.matches?.(fields)){clearTimeout(timer);timer=setTimeout(()=>search(event.target.value),400);}},true);
document.addEventListener('keydown',event=>{
  if(!event.target.matches?.(fields))return;
  if(event.key==='Enter'&&!event.isComposing){event.preventDefault();event.stopPropagation();search(event.target.value);}
  if(event.key==='Escape'){event.preventDefault();event.stopPropagation();sync('');search('');}
},true);
document.addEventListener('click',event=>{
  const button=event.target.closest?.('[data-cabane-catalog-search-submit]');if(!button)return;
  event.preventDefault();event.stopPropagation();search(button.closest('.cabane-catalog-search__control').querySelector(fields).value);
},true);
const params=new URLSearchParams(location.search);sync(params.get('cabane_q')||'');
if(saleOnly||params.get('cabane_q')||choiceKey(params))void render(params,null,false);
})();

